/* Valores padrão da Calculadora — presets de margem/lucro e perfis de taxas
   prontos. Tudo aqui é só ponto de partida: o usuário pode editar/salvar
   os próprios perfis em Configurações → Precificação (perfil.precificacao). */

export const MARGEM_PRESETS = [20, 30, 40, 50, 60, 80];

// Chave de localStorage legada (já usada pela Calculadora antiga) — mantida
// como cache local; o valor "de verdade" agora também pode vir de
// perfil.precificacao.margemPadrao (users/{uid}, ver useCalculoProduto).
export const MARGEM_PADRAO_LS_KEY = "3dp_calc_margem";

// R$/kWh — média residencial/comercial brasileira, só um ponto de partida
// razoável até o usuário configurar o valor real da própria conta de luz.
export const VALOR_KWH_PADRAO = 0.95;

// Perfis de taxas prontos pro usuário adaptar — "Venda direta" não tem
// nenhuma taxa (cliente paga fora de plataforma); os demais são exemplos
// de faixas comuns pra editar com os valores reais do usuário.
//
// Marketplace NÃO entra aqui de propósito. Taxa de Shopee/Mercado Livre não
// é um percentual só: tem uma parte fixa em R$ que muda por faixa de preço
// (e que um perfil de % não consegue representar), e a tabela real é
// buscada na fonte oficial (constants/lojasOnline.js + useTaxasLojas). Os
// perfis "Shopee 14%+3%" e "ML 16%" que existiam aqui eram uma segunda
// tabela, desatualizada e sem a parte fixa — e, aplicados junto com o
// simulador 🛒 Loja online, descontavam a comissão duas vezes.
export const PERFIS_TAXAS_PADRAO = [
  { id: "direta", nome: "Venda direta", taxas: [] },
  { id: "loja", nome: "Loja online própria", taxas: [{ nome: "Taxa de pagamento", pct: 4 }] },
];

export const OBJETIVOS = [
  { id: "margem", label: "Definir margem", unidade: "%" },
  { id: "lucro", label: "Definir lucro", unidade: "R$" },
  { id: "preco", label: "Definir preço", unidade: "R$" },
];
